<template>
<div class="app">
	<b-navbar toggleable="xl" type="dark" variant="dark" sticky fixed>
		<b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
			<b-navbar-brand href="#"><img src="./assets/logo.png" height="64"></img></b-navbar-brand>
			<b-collapse is-nav id="nav_collapse">
				<b-navbar-nav>
					<b-nav-item to="/">Home</b-nav-item>
					<b-nav-item v-if="authenticationService.isAuthenticated()" to="/dashboard">Dashboard</b-nav-item>
					<b-nav-item v-if="authenticationService.isAuthenticated()" to="/servers">Servers</b-nav-item>
				</b-navbar-nav>
				<b-navbar-nav class="ml-auto">
					<b-nav-item v-if="authenticationService.isAuthenticated() === false" to="/login"">Login</b-nav-item>
					<b-nav-item-dropdown id="user-dropdown" v-if="authenticationService.isAuthenticated() === true" :text="user.displayName" toggle-class="nav-link-custom" right>
						<template v-slot:button-content>
							<b-img :src="user.imageUrl" rounded="circle" width="32"></b-img>&nbsp;{{user.displayName}}
						</template>
						<!-- 
						<b-dropdown-item to="/user/profile">User Profile</b-dropdown-item>
						 -->
						<b-dropdown-item to="/user/password">Change Password</b-dropdown-item>
						<b-dropdown-divider></b-dropdown-divider>
						<b-dropdown-item @click="logout()">Logout</b-dropdown-item>
					</b-nav-item-dropdown>
					<b-nav-item-dropdown id="help-dropdown" text="Help" toggle-class="nav-link-custom" right>
						<b-dropdown-item to="/help">Help</b-dropdown-item>
						<b-dropdown-item href="https://www.teedrei.com" target="new">Documentation</b-dropdown-item>
						<b-dropdown-divider></b-dropdown-divider>
						<b-dropdown-item to="/about">About</b-dropdown-item>
					</b-nav-item-dropdown>
				</b-navbar-nav>
			</b-navbar-nav>
		</b-collapse>
	</b-navbar>
	<router-view/>
</div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import {authenticationService} from './services/AuthenticationService'
import router from './router'

export default {
  name: 'app',
  data: () => ({
    authenticationService: authenticationService
  }),
  computed: {
    user: function () {
      return authenticationService.getUser()
    }
  },
  methods: {
    logout () {
      authenticationService.logout()
      router.push('/login')
    }
  }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// App.vue?4c7cde8c